import React from "react";
import { motion } from "framer-motion";

const GAUGES = [
  { key: "ai_career_score", label: "AI Career Score" },
  { key: "job_readiness_pct", label: "Job Readiness" },
  { key: "ai_learning_score", label: "AI Learning Score" },
  { key: "interview_readiness_score", label: "Interview Readiness" },
  { key: "portfolio_completion_pct", label: "Portfolio Complete" },
];

function Gauge({ score, label, delay }) {
  const color = score >= 75 ? "#10B981" : score >= 45 ? "#FBBF24" : "#F87171";
  const circumference = 2 * Math.PI * 34;
  const offset = circumference - (score / 100) * circumference;
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay }}
      className="flex flex-col items-center" data-testid={`portfolio-gauge-${label.toLowerCase().replace(/\s/g, "-")}`}
    >
      <div className="relative w-20 h-20">
        <svg className="w-20 h-20 -rotate-90">
          <circle cx="40" cy="40" r="34" stroke="rgba(255,255,255,0.08)" strokeWidth="6" fill="none" />
          <motion.circle
            cx="40" cy="40" r="34" stroke={color} strokeWidth="6" fill="none" strokeDasharray={circumference} strokeLinecap="round"
            initial={{ strokeDashoffset: circumference }} animate={{ strokeDashoffset: offset }} transition={{ duration: 1, ease: "easeOut", delay }}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="font-heading text-lg font-bold text-white">{score}</span>
        </div>
      </div>
      <p className="text-[11px] text-slate-400 mt-2 text-center leading-tight">{label}</p>
    </motion.div>
  );
}

export default function ScoreGaugesRow({ scores }) {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-5 gap-3 sm:gap-6" data-testid="portfolio-score-gauges-row">
      {GAUGES.map((g, i) => (
        <Gauge key={g.key} score={scores[g.key] || 0} label={g.label} delay={i * 0.08} />
      ))}
    </div>
  );
}
